import { BlacklineBillingAuditTabs } from './tabs';

export function BlacklineBillingAudit() {
	return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">
					Blackline Billing Audit
				</h1>
			</div>
			<BlacklineBillingAuditTabs />
		</>
	);
}
